import { ClipboardButton } from './ClipboardButton';

type InlineCodeProps = {
	clipboardButton?: boolean;
	value?: string;
	children?: React.ReactNode;
};

export function InlineCode({ clipboardButton, value, children }: InlineCodeProps) {
	return (
		<code className="inline-flex items-center gap-2 rounded-md border border-gray-200 bg-gray-100 pl-2 font-mono dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300">
			<span>{children}</span>
			{clipboardButton && value && <ClipboardButton value={value} />}
		</code>
	);
}
